import { commonOverlaySmallShadow } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/styles';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { BouColor } from '../../global/bou-colors';
import { getTextStyle } from '../../content/texts/bou-text/text-style';

type Props = {
  title: ReactNode;
  children: ReactNode;
  topBlockColor?: string;
};

export function NoContentBox(props: Props) {
  return (
    <Root>
      {props.topBlockColor && <ColorBlock backgroundColor={props.topBlockColor} />}
      <Title>{props.title}</Title>
      <Content>{props.children}</Content>
    </Root>
  );
}

const Root = styled.div`
  background-color: white;
  border: 1px solid ${BouColor.TOOL_BORDER_CARDS_LIGHT_GRAY};
  border-radius: 4px;
  ${commonOverlaySmallShadow};
  max-width: 450px;
  font-size: 16px;
`;

const Title = styled.div`
  ${getTextStyle({ size: 'small', isBold: true })}
  padding: 14px;
  border-bottom: 1px solid ${BouColor.TOOL_BORDER_LIGHTER_GRAY};
`;

const Content = styled.div`
  ${getTextStyle({ size: 'xxs' })}
  padding: 14px;
`;

const ColorBlock = styled.div<{ backgroundColor: string }>`
  background-color: ${props => props.backgroundColor};
  height: 2px;
`;
